import React from 'react'

class VideoLibrary extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: this.props.video_library || []
		}
	}

	componentWillReceiveProps(props){
		this.setState({
			items: props.video_library || []
		})
	}

	render() {
		return (
			<section className="media_library">
				{ this.state.items && this.state.items.length ?
					<div>
						<h3>Videos</h3>
						<div className="grid">
							{this.state.items.map( item => {
								return (
									<a href={`https://www.youtube.com/watch?v=${decodeURIComponent(item.videoId)}`} target="_blank" key={item.id} data-id={item.id} className="media_container video">
										<img src={decodeURIComponent(item.imageURL)} alt={item.title} />
									</a>
								)
							})}
						</div>
					</div>
					: null
				}
			</section>
		)
	}
}

export default VideoLibrary






/*
import React, { Component } from 'react'

// C0EgzJ0KGxg
// NpOtkhBcc8k
// imtPF2b2Q4M

export default class App extends Component {
    state = {
        videoIds: [],
    }
    // handleAdd (e) {
    //     const videoIds = this.state.videoIds
    //     videoIds.push(e.target.value)
    //     this.setState({
    //         videoIds,
    //     })
    // }
    // handleRemove (videoId) {
    //     const videoIds = this.state.videoIds
    //     videoIds.splice(videoIds.indexOf(videoId), 1)
    //     this.setState({
    //         videoIds,
    //     })
    // }
    render() {
        return (
            <React.Fragment>
                {this.state.videoIds.map( videoId => <div key={videoId}>
                    <iframe
                        title="yt"
                        width="200"
                        height="112.5"
                        src={`https://www.youtube.com/embed/${videoId}`}
                        frameborder="0"
                        allow="accelerometer autoplay encrypted-media gyroscope picture-in-picture"
                    allowfullscreen></iframe>
                    // <div>
                    //     <span>Video ID:{videoId}</span>
                    //     <button onClick={ () => this.handleRemove(videoId)}>Remove video</button>
                    // </div>
                </div>)}
                // <input
                //     type="text"
                //     value=""
                //     placeholder="Enter YouTube Video ID..."
                //     onChange={ e => this.handleAdd(e)} />
            </React.Fragment>
        )
    }
}
*/



// WEBPACK FOOTER //
// ./src/components/video_library.js